// src/components/admin/AdminKrumsConfig.js
import React, { useState, useEffect } from 'react';
import { 
  listarCostos, actualizarCosto,
  getRecompensa, actualizarRecompensa,
  listarLimites, actualizarLimite
} from '../../services/api';

const AdminKrumsConfig = () => {
  const [costos, setCostos] = useState([]);
  const [recompensa, setRecompensa] = useState(null);
  const [limites, setLimites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mensaje, setMensaje] = useState({ type: '', text: '' });

  useEffect(() => {
    cargarTodo();
  }, []);

  const cargarTodo = async () => {
    setLoading(true);
    try {
      const [costosRes, recompensaRes, limitesRes] = await Promise.all([
        listarCostos(),
        getRecompensa(),
        listarLimites()
      ]);
      setCostos(costosRes.data.costos);
      setRecompensa(recompensaRes.data.recompensa);
      setLimites(limitesRes.data.limites);
    } catch (error) {
      console.error('Error cargando configuraciones:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleActualizarCosto = async (id, krums) => {
    try {
      await actualizarCosto(id, { krums: parseInt(krums) });
      setMensaje({ type: 'success', text: '✅ Costo actualizado' });
      cargarTodo();
      setTimeout(() => setMensaje({ type: '', text: '' }), 3000);
    } catch (error) {
      setMensaje({ type: 'error', text: '❌ Error al actualizar' });
    }
  };

  const handleActualizarRecompensa = async (e) => {
    e.preventDefault();
    try {
      await actualizarRecompensa(recompensa);
      setMensaje({ type: 'success', text: '✅ Recompensa actualizada' });
      setTimeout(() => setMensaje({ type: '', text: '' }), 3000);
    } catch (error) {
      setMensaje({ type: 'error', text: '❌ Error al actualizar' });
    }
  };

  if (loading) return <div className="loading">Cargando configuraciones...</div>;

  return (
    <div className="admin-krums-config">
      <h2>💰 Configuración Global de Krums</h2>
      
      {mensaje.text && (
        <div className={`mensaje ${mensaje.type}`}>{mensaje.text}</div>
      )}

      {/* SECCIÓN 1: Costos de Acciones */}
      <div className="config-seccion">
        <h3>⚡ Costos de Acciones</h3>
        <p className="seccion-desc">Modifica cuántos Krums cuesta cada acción</p>
        
        <table className="tabla-costos">
          <thead>
            <tr>
              <th>Acción</th>
              <th>Descripción</th>
              <th>Krums</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {costos.map(costo => (
              <tr key={costo.id}>
                <td><strong>{costo.accion}</strong></td>
                <td>{costo.descripcion}</td>
                <td>
                  <input
                    type="number"
                    defaultValue={costo.krums}
                    onBlur={(e) => handleActualizarCosto(costo.id, e.target.value)}
                    min="0"
                    className="input-krums"
                    disabled={!costo.editable}
                  />
                </td>
                <td>
                  <span className={`estado-badge ${costo.activo ? 'activo' : 'inactivo'}`}>
                    {costo.activo ? '✅ Activo' : '⏸️ Inactivo'}
                  </span>
                </td>
                <td>
                  <button 
                    onClick={() => handleActualizarCosto(costo.id, costo.krums)}
                    className="btn-guardar-pequeno"
                  >
                    💾
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* SECCIÓN 2: Recompensa Diaria */}
      {recompensa && (
        <div className="config-seccion">
          <h3>🎁 Recompensa Diaria</h3>
          <form onSubmit={handleActualizarRecompensa} className="recompensa-form">
            <div className="form-group">
              <label>Krums por día:</label>
              <input
                type="number"
                value={recompensa.krums}
                onChange={(e) => setRecompensa({...recompensa, krums: parseInt(e.target.value)})}
                min="0"
              />
            </div>
            
            <div className="form-group">
              <label>Máximo acumulable:</label>
              <input
                type="number"
                value={recompensa.max_acumulable}
                onChange={(e) => setRecompensa({...recompensa, max_acumulable: parseInt(e.target.value)})}
                min="0"
              />
            </div>

            <div className="form-group checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={recompensa.solo_texto}
                  onChange={(e) => setRecompensa({...recompensa, solo_texto: e.target.checked})}
                />
                Solo para texto (no imágenes)
              </label>
            </div>

            <button type="submit" className="btn-guardar">
              Actualizar recompensa diaria
            </button>
          </form>
        </div>
      )}

      {/* SECCIÓN 3: Límites Beta */}
      <div className="config-seccion">
        <h3>⚖️ Límites para Beta Testers</h3>
        
        <table className="tabla-limites">
          <thead>
            <tr>
              <th>Rol</th>
              <th>Imágenes/día</th>
              <th>Texto/día</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {limites.map(limite => (
              <tr key={limite.id}>
                <td><strong>{limite.rol}</strong></td>
                <td>
                  <input
                    type="number"
                    defaultValue={limite.max_imagenes_dia}
                    onBlur={(e) => {
                      // Aquí iría la actualización
                    }}
                    min="0"
                    className="input-limite"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    defaultValue={limite.max_texto_dia}
                    onBlur={(e) => {
                      // Aquí iría la actualización
                    }}
                    min="0"
                    className="input-limite"
                  />
                </td>
                <td>
                  <span className={`estado-badge ${limite.activo ? 'activo' : 'inactivo'}`}>
                    {limite.activo ? '✅ Activo' : '⏸️ Inactivo'}
                  </span>
                </td>
                <td>
                  <button className="btn-guardar-pequeno">💾</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="info-box">
        <h4>ℹ️ Notas importantes</h4>
        <ul>
          <li>Los cambios a costos aplican inmediatamente</li>
          <li>La recompensa diaria se actualiza al día siguiente</li>
          <li>Los límites beta afectan solo a usuarios con rol 'beta'</li>
        </ul>
      </div>
    </div>
  );
};

export default AdminKrumsConfig;